export function getPackageDisplayName(packageId: string): string {
  const names: Record<string, string> = {
    "pkg-concept-to-blueprint": "Concept to Blueprint",
    "pkg-mvp-rescue-audit": "MVP Rescue Audit",
    "pkg-desktop-feasibility": "Desktop Feasibility Sprint",
    "pkg-ai-desktop-launch": "AI Desktop Launch",
    "pkg-shipping-ops-partner": "Shipping & Ops Partner",
  };
  return names[packageId] || packageId;
}
